<template>
  <div id="app">
    <div v-if="$route.path.includes('courseOL') || $route.path.includes('login')">
      <router-view></router-view>
    </div>
    <div v-else>
      <el-container v-if="hidlist">
        <el-header class="foijks" height="48px">
          <div :style="{ width: isCollspan ? '64px' : '210px' }" style="width: 180px; float: left; font-size: 16px !important; line-height: 48px; padding: 0 10px; transition: all 0.2s ease">
            {{ isCollspan ? '' :schoolName?schoolName: '京师成长阅读系统' }}
          </div>
          <div style="flex: 2.5; float: left; line-height: 48px; overflow: hidden; display: flex; align-items: center; justify-content: space-between">
            <i :class="isCollspan ? 'el-icon-s-unfold' : 'el-icon-s-fold'" style="cursor: pointer; font-size: 20px !important; vertical-align: middle" @click="isCollspan = !isCollspan"></i>
            <div style="font-size: 14px; height: 48px; line-height: 48px">
              <span @click="navTo(item)" :class="item.appId == 42 ? 'nowApp' : ''" style="cursor: pointer; margin-right: 25px" v-for="(item, index) in appList" :key="item.appId"
                ><i :class="icons[index % 3]" style="margin-right: 10px"></i>{{ item.appName }}</span
              >
              <!-- <span @click="evaluate" style="cursor: pointer; margin-right: 25px" v-if="roleId == '-1004'"> <i class="el-icon-data-line" style="margin-right: 10px"></i>综合素质评价</span>
              <span class="nowApp" style="cursor: pointer; margin-right: 25px"> <i class="el-icon-document" style="margin-right: 10px"></i>阅读管理</span>
              <span @click="toData" style="cursor: pointer; margin-right: 25px" v-if="roleId == '-1004'"><i class="el-icon-data-analysis" style="margin-right: 10px"></i>数据中心</span>
              <span @click="daping" style="cursor: pointer; margin-right: 25px" v-if="roleId == '-1004'"> <i class="el-icon-data-line" style="margin-right: 10px"></i>数据大屏</span>
              <span @click="jichu" style="cursor: pointer; margin-right: 25px" v-if="roleId == '-1004' || isClass"><i class="el-icon-data-analysis" style="margin-right: 10px"></i>基础数据</span> -->
              <!-- <span style="cursor: pointer; margin-right: 25px"><i class="el-icon-reading" style="margin-right: 10px"></i>阅读</span>
              <span style="cursor: pointer; margin-right: 25px"><i class="el-icon-basketball" style="margin-right: 10px"></i>研学</span> -->
            </div>
            <div style="width: 20px; height: 48px"></div>
            <!-- <el-menu style="border: 0" :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
              <el-menu-item :index="String(index)" v-for="(list, index) in html" :key="index">{{ list.name }}</el-menu-item>
            </el-menu> -->
          </div>
          <div style="flex: 1; float: left; font-size: 14px !important; line-height: 48px; text-align: right">
            <span @click="daping" style="cursor: pointer; margin-right: 25px" v-if="roleId != -1002"> <i class="el-icon-data-line" style="margin-right: 10px"></i>数据大屏</span>
            <span style="margin-right: 10px">{{ schoolName }}</span>
            <i class="el-icon-full-screen" style="margin-right: 10px" @click="fullScreen"></i>
            <!--<el-popover placement="bottom" title="" width="100" trigger="click" style="text-align: center;">
						<el-button @click="tui">退出登录</el-button>
						<el-avatar :src="circleUrl" :size="35" slot="reference"></el-avatar>
					</el-popover>-->
            <div style="padding-left: 10px; display: block; float: right; margin-right: 20px; line-height: 48px">
              <!-- <span v-if="roleId != -1002 && authSource == 'system'" @click="quanhj" style="cursor: pointer; margin-right: 25px">工作台</span> -->
              <!-- <span @click="quanhj1" style="cursor:pointer;margin-right: 30px;">公告</span> -->
              <el-popover placement="bottom" title="" width="100" trigger="click" style="text-align: center">
                <div class="header_right_se">
                  <div
                    v-for="item in roleByUserData"
                    style="font-size: 14px"
                    :key="item.id"
                    v-if="item.id != '-1006' || item.id != '-1002'"
                    v-show="item.id == roleId ? false : true"
                    @click="qiehuan(item.id)"
                  >
                    切换 {{ item.name }}
                  </div>
                </div>
                <div class="header_right_se" @click="toPassWord" style="margin-bottom: 10px" v-if="roleId == '-1003'">
                  <div style="font-size: 14px">
                    <i class="el-icon-lock"></i>
                    修改密码
                  </div>
                </div>
                <div class="unLogin" @click="tui">退出登录</div>
                <div slot="reference" style="cursor: pointer" class="huanhangs">
                  <!-- <ww-open-data v-if="authSource!='system'" type="userName" :openid="names"></ww-open-data> -->
                  <!-- <span v-else>{{names}}</span> -->
                  <span>{{ names }}</span>
                  <!-- {{names}} -->
                </div>
              </el-popover>
            </div>
          </div>
        </el-header>
        <el-container v-if="roleId != '-1001'" style="background-color: #f7f7f7; margin-top: 60px; padding: 0px 10px">
          <el-aside :width="isCollspan ? '64px' : '230px'" class="huijsd">
            <el-menu
              :unique-opened="true"
              :collapse-transition="false"
              :default-active="$route.path"
              class="el-menu-vertical-demo"
              @select="handleSelect"
              @open="handleOpen"
              @close="handleClose"
              :collapse="isCollspan"
            >
              <el-submenu :index="String(index)" v-for="(list, index) in html" :key="index" v-if="list.menuList">
                <template slot="title">
                  <i class="el-icon-location"></i>
                  <span slot="title">{{ list.name }}</span>
                </template>
                <el-menu-item :index="String(list2.html)" v-for="list2 in list.menuList" :key="list2.id" :route="String(list2.html)">
                  <span slot="title">{{ list2.name }}</span>
                </el-menu-item>
              </el-submenu>
              <el-menu-item class="navItem" :index="String(list.html)" :route="String(list.html)" v-else>
                <i class="el-icon-location"></i>
                <span slot="title">{{ list.name }}</span>
              </el-menu-item>
            </el-menu>
          </el-aside>
          <el-main class="fhui">
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>

            <router-view v-if="!$route.meta.keepAlive"></router-view>
            <!-- <div style="height: 150px;"></div> -->
          </el-main>
        </el-container>
        <el-container v-else class="studen_con" style="margin-top: 60px">
          <el-aside width="230px" v-show="show" :class="show ? 'huijsd' : ''">
            <el-menu
              :unique-opened="true"
              style="border-right: solid 10px #fafafa"
              :default-active="$route.path"
              class="el-menu-vertical-demo"
              @select="handleSelect"
              @open="handleOpen"
              @close="handleClose"
              :collapse="isCollspan"
            >
              <el-submenu :index="String(index)" v-for="(list, index) in html" :key="index">
                <template slot="title">
                  <i class="el-icon-location"></i>
                  <span slot="title">{{ list.name }}</span>
                </template>
                <el-menu-item :index="String(list2.html)" v-for="list2 in list.menuList" :key="list2.id" :route="String(list2.html)">
                  <span slot="title">{{ list2.name }}</span>
                </el-menu-item>
              </el-submenu>
            </el-menu>
          </el-aside>
          <el-main class="student_main" :class="show ? 'fhui' : 'feuihuj'">
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>

            <router-view v-if="!$route.meta.keepAlive"></router-view>
            <div class="bg_home"></div>
            <!-- <div style="height: 150px;"></div> -->
          </el-main>
        </el-container>
      </el-container>
      <div v-else>
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>

        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
    </div>
    <el-dialog :modal-append-to-body="false" title="修改密码" :visible.sync="passwordDialog" width="30%" :before-close="onPassClose">
      <pass-word ref="password"></pass-word>
    </el-dialog>
  </div>
</template>
<script>
// AES 加密
import Crypto from './api/aes.js'
import { BASE_TOKEN } from '@/api/index'
import { MenuTreeByUser, UserLogout, usercenterinfo, dapingurl, zongpingurl, dataurl, roleByUser, getAppList, tui } from '@/api/home'
import { initWxConfig } from '@/api/initWxConfig'
import passWord from './components/password/index.vue'
initWxConfig(this)
export default {
  components: {
    passWord
  },
  data() {
    return {
      icons: ['el-icon-data-line', 'el-icon-document', 'el-icon-data-analysis'],
      passwordDialog: false,
      schoolName: '',
      show: false,
      activeIndex: '',
      html: [],
      erji: [],
      circleUrl: '',
      names: '',
      info: [],
      roleId: '',
      hidlist: true,
      isCollspan: false,
      roleByUserData: [],
      appList: [],
      isClass: false,
    }
  },
  watch: {},
  methods: {
    quanhj() {
      window.location = tui
    },
    navTo(item) {
      if (item.appId == 42) return
      let html = item.appUrl + '?roleId=' + localStorage.getItem('roleId') + '&token=' + localStorage.getItem('token')+
        "&url=" +
        localStorage.getItem("url");
      window.open(html, '_blank')
    },
    evaluate() {
      window.open(zongpingurl + '/#/?token=' + localStorage.getItem('token') + '&roleId=' + this.roleId+
        "&url=" +
        localStorage.getItem("url"));
      // window.open('http://beta.sso.jingshidata.com/#/' + '?token=' + localStorage.getItem('token') + '&roleId=' + localStorage.getItem('roleId'))
    },
    toData() {
      let html = dataurl + '/#/?roleId=' + this.roleId + '&token=' + localStorage.getItem('token')
      window.open(html, '_blank')
    },
    onPassClose(done) {
      this.$refs.password.resetForm()
      this.$refs.password.$refs['ruleForm'].clearValidate()
      done()
    },
    toPassWord() {
      this.passwordDialog = true
    },
    qiehuan(id) {
      this.roleId = id
      if (id == '-1003') {
        localStorage.setItem('roleType', 'teacher')
        this.roleType = 'teacher'
      } else {
        localStorage.setItem('roleType', 'school')
        this.roleType = 'school'
      }
      localStorage.setItem('roleId', this.roleId)
      location.reload()
    },
    // 获取自己全部角色
    async roleByUser() {
      const { data: res } = await roleByUser()
      this.roleByUserData = res.data
      console.log(res.data)
    },
    fullScreen() {
      var isFullScreen = document.fullscreen || document.mozFullScreen || document.webkitIsFullScreen
      if (isFullScreen) {
        if (document.exitFullScreen) {
          document.exitFullScreen()
          //兼容Firefox
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
          //兼容Chrome, Safari and Opera等
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
          //兼容IE/Edge
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        const element = document.documentElement
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen()
        }
      }
    },
    jichu() {
      window.open('http://beta.school.jingshidata.com/#/' + '?token=' + localStorage.getItem('token') + '&roleId='+this.roleId+"&url=" +localStorage.getItem("url"));
      // window.open('http://school.jingshidata.com/#/' + '?token=' + localStorage.getItem('token') + '&roleId=' + localStorage.getItem('roleId'))
    },
    handleSelect(key, keyPath) {
      this.$router.push({
        path: key
      })
    },
    daping() {
      let html = dapingurl + '/#/read?schoolId=' + this.info.schoolId + '&token=' + localStorage.getItem('token')+
        "&url=" +
        localStorage.getItem("url");
      window.open(html, '_blank')
    },
    quanhj1() {
      this.activeIndex = ''
      this.$router.push({
        path: '/notice/index'
      })
    },
    handleSelect1(key, keyPath) {
      this.$router.push({
        path: key
      })
    },
    handleOpen(key, keyPath) {
      this.activeIndex = key
      localStorage.setItem('activeIndex', key)
      if (!this.html[key].isLeaf) {
        this.show = true
        this.erji = this.html[key].menuList
        this.$router.push({
          path: this.html[key].menuList[0].html
        })
      } else {
        this.show = false
        let url = '/' + this.html[key].html
        this.$router.push({
          path: url
        })
        console.log(url)
      }
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    getAppList() {
      let pam = {
        id: this.roleId
      }
      getAppList(pam).then((res) => {
        this.appList = res.data.data
        let i = 0
        while (i < this.appList.length) {
          let item = this.appList[i]
          if (!item.appRoles.includes(this.roleId)) {
            this.appList.splice(i, 1)
          } else {
            i++
          }
        }
      })
    },
    quanxian() {
      let that = this
      let params = {
        appCode: 'JSYUEDU',
        menuType: 1,
        roleId: this.roleId
      }
      if (!localStorage.getItem('roleId')) {
        return this.$message.error('登录失败，请返回重试！')
      }
      MenuTreeByUser(params)
        .then((res) => {
          if (res.data) {
            let num = ''
            that.html = res.data.data
            localStorage.setItem('JSYUEDU', JSON.stringify(res.data.data))
            localStorage.setItem('appSecret', 'U2FsdGVkX19OZOcU4KhX71qxjqtm9nOk03RcHEUlLpY=')
            if (that.$route.path == '/') {
              that.activeIndex = '0'
              if (!that.html[0].isLeaf) {
                // that.show = true
                that.erji = that.html[0].menuList
                that.$router.push({
                  path: that.html[0].menuList[0].html
                })
              } else {
                // that.show = false
                let url = that.html[0].html
                console.log('url', url)
                that.$router.push({
                  path: url
                })
              }
            }
            // else {
            //   for (var i = 0; i < that.html.length; i++) {
            //     if (!that.html[i].isLeaf) {
            //       that.show = true
            //       that.erji = that.html[i].menuList
            //       console.log(that.$route.path)
            //       for (var s = 0; s < that.html[i].menuList.length; s++) {
            //         if (that.$route.path == that.html[i].menuList[s].html) {
            //           // that.activeIndex = i
            //           num = i
            //           that.activeIndex = i.toString()
            //           that.$router.push({
            //             path: that.html[i].menuList[s].html
            //           })
            //           return false
            //         }
            //       }
            //     } else {
            //       that.show = false
            //       let url = that.html[i].html
            //       that.$router.push({
            //         path: url
            //       })
            //     }
            //   }
            // }
            if (num == '') {
              that.$router.push({
                path: that.html[0].menuList[0].html
              })
            }
            if (that.$route.path == '/notice/index') {
              that.activeIndex = ''
            } else {
              that.activeIndex = that.activeIndex
            }
          }
        })
        .catch(() => {})
    },
    yonghui() {
      let that = this
      usercenterinfo()
        .then((res) => {
          that.info = res.data.data
          localStorage.setItem('info', JSON.stringify(res.data.data))
          this.quanxian()
          this.getAppList()
        })
        .catch(() => {})
    },
    UsercenterGetInfo() {
      let that = this
      usercenterinfo()
        .then((res) => {
          that.roleType = res.data.data.roleType
          that.circleUrl = res.data.data.hostUrl
          localStorage.setItem('roleType', res.data.data.roleType)
          localStorage.setItem('authSource', res.data.data.authSource)
          that.authSource = res.data.data.authSource
          localStorage.setItem('userId', res.data.data.userId)
          if (!localStorage.getItem('roleId')) {
            if (res.data.data.roleType == 'teacher') {
              this.roleId = -1003
              localStorage.setItem('roleId', -1003)
            } else if (res.data.data.roleType == 'school') {
              this.roleId = -1004
              localStorage.setItem('roleId', -1004)
            } else {
              this.roleId = -1001
              localStorage.setItem('roleId', -1001)
            }
          }
          if (res.data.data.roleType == 'teacher') {
            localStorage.setItem('teacherId', res.data.data.teacher.id)
            that.names = res.data.data.teacher.name
            that.schoolName = res.data.data.teacher.schoolName
            if (res.data.data.teacher.classesVo) {
              that.isClass = true
            }
          } else if (res.data.data.roleType == 'school') {
            that.names = res.data.data.school.name
            that.schoolName = res.data.data.school.schoolName
          } else {
            that.names = res.data.data.parent.name
          }

          this.yonghui()
          this.roleByUser()
        })
        .catch(() => {})
    },
    tui() {
      let that = this
      if(localStorage.getItem('url')){
        window.location.href = localStorage.getItem('url');
        return
      }
      UserLogout()
        .then((res) => {
          localStorage.clear()
          // this.$router.replace('/login')
          window.location.href = BASE_TOKEN
        })
        .catch(() => {})
    }
  },
  destroyed() {
    // console.log("我已经离开了！");
    // localStorage.setItem("activeIndex", "0");
  },
  created() {},
  mounted() {
    // return
    if (this.$route.path.includes('courseOL')) {
      return
    }
    if (this.$route.path == '/login') {
      if (localStorage.getItem('token')) {
        this.$router.replace('/')
      }
    }
    let that = this
    if (that.$route.query.token) {
      let token = that.$route.query.token
      localStorage.setItem('token', token)
      localStorage.setItem('url', that.$route.query.url)
      if (that.$route.query.roleId) {
        localStorage.setItem('roleId', that.$route.query.roleId)
        this.roleId = that.$route.query.roleId
      } else {
        // this.$message.error('登录失败，请重新登录')
      }
    } else if (localStorage.getItem('token')) {
      this.roleId = localStorage.getItem('roleId').split(",")[0]
    } else {
      // this.$message.error('登录失败，请重新登录')
      // setTimeout(() => {
      //   this.$router.replace('/login')
      // }, 500)
      // window.location.href = BASE_TOKEN
    }
    if (localStorage.getItem('roleId')) {
      this.UsercenterGetInfo()
    } else {
      // this.$message.error('登录失效，请重新登录')
      // setTimeout(() => {
      //   this.$router.replace('/login')
      // }, 500)
      // window.location.href = BASE_TOKEN
    }
  }
}
</script>

<style scoped>
.el-popper[x-placement^='bottom'] {
  text-align: center;
}
.studen_con {
  height: 93vh;
}
.bg_home {
  position: fixed;
  background: url('./assets/img/bg-home.png') no-repeat;
  background-position: bottom;
  background-size: 100%;
  background-color: #eaeffc;
  top: 0;
  left: 0;
  z-index: -1;
  height: 100%;
  width: 100%;
}
.w-e-full-screen-container {
  z-index: 9999;
}
.el-menu-item.is-active {
  background-color: #ecf5ff;
}
.el-menu-item {
  text-align: left;
  padding-left: 50px !important;
}
.navItem {
  padding-left: 20px !important;
}
.header_right_se div {
  cursor: pointer;
  list-style: none;
  height: 30px;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
  margin-bottom: 10px;
}
.header_right_se div:hover {
  background-color: #f4f4f4;
}
.unLogin {
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #409eff;
  color: #fff;
}
.nowApp {
  position: relative;
}
.nowApp::after {
  content: '';
  position: absolute;
  width: 100%;
  background-color: #fff;
  height: 3px;
  left: 0;
  bottom: -15px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue